import {$authHost} from "./index";

export const taskAdd = async (task) => {
    const { data } = await $authHost.post('api/task/add', { task })

    return data
}

export const taskCheck = async (task) => {
    const { data } = await $authHost.post('api/task/check', { task })

    return data
}